module.exports = __webpack_public_path__ + "img/1_036.94501b1a.jpg";